// Faint own-row wash used to mark the current user's row in the schedule grid
// and the setup boards — one token so all tables tint "me" identically.
// Neutral grey, not gold --primary: a colored wash fought the blue raid columns
// where they crossed. Opaque (mixed with --background, not an alpha) so the sticky
// name column masks day cells scrolling under it.
export const MY_ROW_TINT =
  "bg-[color-mix(in_oklab,var(--foreground)_3%,var(--background))]";
